"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findObjectInListById = exports.modifyObjectWithFactorById = exports.modifyObjectWithFactor = void 0;
// This method updates the JSON array with the additional parameter passed from the calling fn.
function modifyObjectWithFactor(obj, factor, tobeChecked, tobeChanged) {
    var matchedObject = obj.find(function (value) { return value[factor] === tobeChecked; });
    if (matchedObject) {
        matchedObject[factor] = tobeChanged;
    }
    return obj;
}
exports.modifyObjectWithFactor = modifyObjectWithFactor;
// This method modifies the JSON array with the new factor, provided the ID passed is matched.
function modifyObjectWithFactorById(obj, idTobeModified, factor, tobeChanged) {
    obj.find(function (_a) {
        var id = _a.id;
        return id === idTobeModified;
    })[factor] = tobeChanged;
    return obj;
}
exports.modifyObjectWithFactorById = modifyObjectWithFactorById;
function findObjectInListById(list, id) {
    return list.find(function (obj) { return obj.id === id; });
}
exports.findObjectInListById = findObjectInListById;
